function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 11.5,
  stroke: "#FF9977"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 10,
  fill: "#FF9977",
  stroke: "#FF9977"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.58313 13.75L9.08313 17.25L18.4165 6.75",
  stroke: "#FFFEFA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCheckCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.eb491c1c.svg";
export { ForwardRef as ReactComponent };